<script>
//Components
const Hero = () => import("@/components/media/Hero.vue");

export default {
  name: "diversidade",
  data() {
    return {};
  },
  head() {
    return this.$head({
      title: "Diversidade",
    });
  },
  components: {
    Hero,
  },
  computed: {},
};
</script>

<template>
  <section class="diversity">
    <Hero
      title=""
      :image="'banner-inclusao.png'"
      height="75vh"
      :search="false"
    />
    <div class="container">
      <header>
        <h1 class="title">DIVERSIDADE E INCLUSÃO</h1>
        <h2>
          Diferente todo mundo é, indiferente
          <div class="break d-md-block d-none"></div>
          ninguém precisa ser.
        </h2>
      </header>
      <div class="diversity__piers">
        <span class="text-center">PILARES DA DIVERSIDADE</span>
      </div>
      <div class="diversity__box">
        <div>
          <div>
            <img
              src="@/assets/images/confidence/img-multigeracional.png"
              alt=""
            />
            <span> Multigeracional </span>
          </div>
          <div>
            <img src="@/assets/images/confidence/img-genero.png" alt="" />
            <span> Gênero </span>
          </div>
          <div>
            <img src="@/assets/images/confidence/img-multirracial.png" alt="" />
            <span> Multirracial </span>
          </div>
          <div>
            <img src="@/assets/images/confidence/img-lgbt.png" alt="" />
            <span> LGBT+ </span>
          </div>
          <div>
            <img src="@/assets/images/confidence/img-pcd.png" alt="" />
            <span> PCDs </span>
          </div>
        </div>
        <p>
          Para o Grupo Travelex Confidence, Diversidade e Inclusão significam
          proporcionar uma cultura em que todas as pessoas tenham o poder de
          serem quem elas realmente são no trabalho, pois valorizamos as
          perspectivas e os talentos singulares de nossos funcionários.​ Estamos
          sempre nos esforçando para que as pessoas sintam-se conectadas
          globalmente. Nossos negócios abrangem todo o mundo e nossos
          colaboradores são tão diversos quanto nossos clientes. <br />
          <br />
          A nossa estratégia é abrangente e sustentada por cinco pautas de
          diversidade:​
        </p>

        <ul>
          <li>
            <h3>1. Bem-estar</h3>
            <p>
              de acordo com a Organização Mundial da Saúde, o bem-estar mental é
              a causa mais comum de doenças em todo o mundo, por isso, estamos
              comprometidos em preservar e apoiar a saúde mental de nossos
              colaboradores. ​
            </p>
          </li>
          <li>
            <h3>2. NEAR</h3>
            <p>
              incluindo diferentes Nacionalidades, Etnias, Associações e Raças,
              essa pauta se concentra em oferecer uma cultura de trabalho que
              apoia pessoas de todas as origens. Reconhecemos, ainda, a
              importância de convidar diferentes pessoas para o debate, já que
              embora uma pessoa possa não pertencer a uma minoria, ela pode ser
              próxima de alguém que pertença. Assim, expandimos e reverberamos
              essa pauta.
            </p>
          </li>
          <li>
            <h3>3. Gênero</h3>
            <p>
              se concentra na criação de uma cultura de trabalho que garanta uma
              equidade entre os gêneros em todos os níveis da organização,
              oferecendo oportunidades iguais de desenvolvimento. ​
            </p>
          </li>
          <li>
            <h3>4. LGBTQIA+</h3>
            <p>
              esta vertente da nossa estratégia apoiará colaboradores da sigla
              que se identifiquem com as múltiplas orientações sexuais e
              identidades de gênero, sem distinção de cargos, promovendo um
              ambiente com respeito e acolhimento.
            </p>
          </li>
          <li>
            <h3>5. PcD</h3>
            <p>
              esta frente busca promover uma cultura inclusiva para os
              colaboradores com necessidades especiais, oferecendo oportunidades
              iguais, ampliando a pluralidade de pessoas em nossos ambientes e
              lutando por espaços livres de preconceitos.
            </p>
          </li>
        </ul>
        <p class="mb-5 pb-4">
          No Grupo Travelex Confidence estamos comprometidos em fornecer uma
          cultura no local de trabalho em que todos se sintam apoiados, em que
          os colaboradores possam ser eles mesmos e oferecer um serviço de nível
          internacional para nossos clientes. Quando o assunto é Diversidade e
          Inclusão, todos ganham.
        </p>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
h2 {
  font-size: 2.6rem !important;
  margin-top: 3rem;
  @include media-breakpoint-down(md) {
    font-size: 1.7rem !important;
  }
}
.diversity {
  &__piers {
    span {
      display: block;
      width: 100%;
      letter-spacing: 1.2px;
      color: #212644;
      text-transform: uppercase;
      font-size: 1.5rem;
      font-weight: 500;
      margin-top: 2rem;
      @include media-breakpoint-down(md) {
        font-size: 1.2rem;
        font-weight: 500;
        margin-bottom: -1.5rem;
      }
    }
  }
  &__box {
    margin-top: 2rem;
    & > div {
      display: flex;
      justify-content: space-between;
      & > div {
        width: calc((100% / 5) - 3rem);
        box-sizing: border-box;
        text-align: center;
        span {
          margin-top: 1rem;
          display: block;
          font-weight: bold;
          font-size: 1.2rem;
        }
        img {
          width: 100%;
        }
      }
      @include media-breakpoint-down(md) {
        flex-flow: row wrap;
        & > div {
          width: calc((100% / 2) - 2rem);
          margin-top: 1rem;
          span {
            margin-top: 1rem;
            font-size: 1rem;
          }
        }
      }
    }
    p {
      margin-top: 3rem;
      font-size: 1.1rem;
      line-height: calc(1.1rem * 1.6);
      max-width: 780px;
    }
    ul {
      margin: 0px;
      padding: 0px;
      margin-top: 2rem;
      border-top: 1px solid rgba(#000, 0.1);
      max-width: 800px;
      padding: 0rem 0px 0rem 0px;
      li {
        h3 {
          margin: 0px;
          padding: 0px;
          color: #212644 !important;
          @include media-breakpoint-down(md) {
            font-size: 1.3rem !important;
          }
        }
        p {
          margin-top: 1rem;
        }
        border-bottom: 1px solid rgba(#000, 0.1);
        padding: 2.5rem 0px;
        @include media-breakpoint-down(md) {
          padding: 1rem 0px;
        }
      }
    }
  }
}
</style>

